import { de, enUS } from 'date-fns/locale'

export const locales = { en: enUS, de: de }
